import { render, staticRenderFns } from "./InstructorModal.vue?vue&type=template&id=b937dc88&"
import script from "./InstructorModal.vue?vue&type=script&lang=js&"
export * from "./InstructorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports